module.exports = __webpack_public_path__ + "static/media/USA.ea44c1f3.jpg";